import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import FluigService from "../../../../services/resource/fluigComprasService";
import { reduzirNome } from "../../../../utils/reduzirNome";
import { Loading } from "../../../../componentes/loading/loading";

function ResumoSolicitantes({ dataInicial, dataFinal, filtrar, openModal }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [tamanho, settamanho] = useState(0);
  const [loading, setLoading] = useState(false);
  const service = new FluigService();

  useEffect(() => {
    setLoading(true);
    service
      .countMaioresSolicitantes(dataInicial, dataFinal)
      .then((response) => {
        const labels = response.data.map((item) =>
          reduzirNome(item.solicitante)
        );
        const data = response.data.map((item) => item.totalSolicitacao);
        settamanho(response.data.length);

        setChartOptions({
          chart: {
            type: "bar",
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const index = config.dataPointIndex;
                const label = labels[index];
                openModal(label, "solicitanteNome");
              },
            },
          },
          xaxis: {
            categories: labels,
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: false,
              columnWidth: "45%",
              distributed: true
            },
          },
          colors: [
            "#f6483bff",
            "#F97316",
            "#22C55E",
            "#393b57ff",
            "#c52294ff",
            "#daf108ff",
          ],
          legend: {
            show: false,
          },
        });

        setChartSeries([
          {
            name: "Quantidade",
            data,
          },
        ]);
      })
      .finally(() => setLoading(false));
  }, [filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Maiores Solicitantes
      </h3>
      <label className="text-muted-foreground text-sm">
        Ranking dos usuários com mais solicitações registradas.
      </label>
      <div className="h-64">
        {!loading && tamanho > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="bar"
            height="100%"
          />
        ) : !loading ? (
          "Não existem dados disponíveis para o intervalo selecionado."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}

export default ResumoSolicitantes;